import React, { useState } from 'react'
import Text from '../../../Text'
import FileDownload from './FileDownload'
import ChevronDownIcon from '../../../icons/ChevronDownIcon'
import styles from './styles.module.css'
import { TYPES } from '../../../../content/downloads'
import { toSrc } from '../../../../utils/imageSrc'

function ItemDownloads({ itemCategory, categoryLabel, categoryImage, latestFiles, archivedFiles }) {
  // Phase B: archived-versions expand/collapse is LOCAL per-category UI state
  // (was Overmind state.archivedFilesVisibility[itemCategory] — read only here).
  const [archivedVisible, setArchivedVisible] = useState(false)

  const typeLabel = (t) => TYPES[t]?.label || t

  // categoryImage is a #67 ResolvedImage descriptor (server-resolved in gSSP,
  // task #80) or, on a fallback path, a legacy /assets string. toSrc collapses
  // either to a URL; when it's a descriptor we also get the responsive srcSet.
  const imageSrc = toSrc(categoryImage)
  const imageSrcSet =
    categoryImage && typeof categoryImage === 'object' ? categoryImage.srcSet : undefined

  return (
    <div className={styles.wrapper}>
      {/* eslint-disable-next-line local-rules/img-requires-dimensions, local-rules/prefer-img-component -- faithful styled.img->img; box fully sized via CSS width/height */}
      <img className={styles.image} src={imageSrc} srcSet={imageSrcSet} alt={`Image of ${categoryLabel}`}/>
      <div className={styles.downloads}>
        <div className={styles.itemName}>
          <Text type='download-item-name'>{categoryLabel}</Text>
        </div>

        {latestFiles.map((file) => (
          <FileDownload
            key={`${file.label}-${file.date}`}
            fileName={file.label}
            fileType={typeLabel(file.type)}
            fileDate={file.date}
            downloadUrl={file.url}
            hideDownloadButton={file.hideDownloadButton}
            warningText={file.warningText}
            howToUrl={file.howToUrl}
          />
        ))}

        {archivedFiles && archivedFiles.length ? (
          <>
            <div className={styles.archivedVersionsExpander}>
              <div className={styles.archivedVersionsButtonAndIconWrapper} onClick={() => setArchivedVisible((v) => !v)}>
                <div className={styles.archivedVersionsButton}>
                  <Text type="caption-1">{archivedVisible ? 'Hide' : 'Show'} archived versions</Text>
                </div>
                <div className={archivedVisible ? styles.showArchivedVersionsIconFlip : styles.showArchivedVersionsIcon}>
                  <ChevronDownIcon/>
                </div>
              </div>
            </div>

            <div className={archivedVisible ? styles.archivedVersionsList : styles.archivedVersionsListHidden}>
              <Text type="h5">Archived Versions</Text>
              {archivedFiles.map((file) => (
                <FileDownload
                  key={`${file.label}-${file.date}`}
                  fileName={file.label}
                  fileType={typeLabel(file.type)}
                  fileDate={file.date}
                  downloadUrl={file.url}
                />
              ))}
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default ItemDownloads
